<div class="flex flex-col pb-[10rem] h-full py-2"> 
  <p-contextmenu #cm [model]="contextMenuItems"></p-contextmenu>

  <ag-grid-angular
    #agGrid
    style="width: 100%; height: 500px;"
    [defaultColDef]="defaultColDef"
    [columnTypes]="columnTypes"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [suppressAggFuncInHeader]="true"
    [rowHeight]="rowHeight"
    [gridOptions]="gridOptions"
    (contextmenu)="$event.preventDefault()"
    (cellContextMenu)="onCellContextMenu($event)"
  />
</div>